import { Link } from "react-router-dom";

// Render text with markdown-style inline tokens:
//   `![alt](/path)`  → inline image
//   `[label](url)`   → inline link (external opens in new tab, internal uses Link)
//   `*italic*`       → italicised span
// External URLs (http/https) open in a new tab; internal paths use React Router.
export function renderInlineLinks(text) {
  if (!text) return null;
  const parts = [];
  // Alternation: image first (so the leading `!` doesn't get confused with the
  // bare link pattern), then link, then italic. Non-greedy captures ensure a
  // dangling `[` or `*` stays as literal text.
  const re = /!\[([^\]]*)\]\((\/[^)\s]+|https?:\/\/[^)\s]+)\)|\[([^\]]+)\]\((\/[^)\s]+|https?:\/\/[^)\s]+)\)|\*([^*\n]+)\*/g;
  let last = 0;
  let m;
  let idx = 0;
  const linkCls =
    "hover:brightness-90 transition-colors";
  const linkStyle = { color: "#fc4707" };
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[2]) {
      // Image
      parts.push(
        <img
          key={`img-${idx++}`}
          src={m[2]}
          alt={m[1] || ""}
          className="my-2 max-w-full h-auto align-middle inline-block"
          loading="lazy"
        />
      );
    } else if (m[3]) {
      const label = m[3];
      const href = m[4];
      const isExternal = /^https?:/i.test(href);
      parts.push(
        isExternal ? (
          <a
            key={`lnk-${idx++}`}
            href={href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={linkCls}
            style={linkStyle}
          >
            {label}
          </a>
        ) : (
          <Link
            key={`lnk-${idx++}`}
            to={href}
            className={linkCls}
            style={linkStyle}
          >
            {label}
          </Link>
        )
      );
    } else if (m[5]) {
      parts.push(
        <em key={`em-${idx++}`} className="italic">
          {m[5]}
        </em>
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
